module.exports = __webpack_public_path__ + "static/with-yoyo-bg1-056f29a65d8af4db231832882bf7f133.jpg";